import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoSalaryBill = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>SalaryBill</title>
    <path
      d="M15.999 11.277v1.571m0 7.856v1.572M18.095 13.895c-1.572-1.572-4.19-1.048-4.19 1.047 0 2.619 3.666 1.048 4.19 3.143.305 1.221-.46 2.62-2.62 2.619-1.57 0-2.27-1.048-2.618-1.572"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <rect
      x={3.285}
      y={6.563}
      width={25.429}
      height={20.857}
      rx={1.286}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <path
      d="M8.57 8.992a2.856 2.856 0 0 1-2.856 2.856M26.286 11.848a2.856 2.856 0 0 1-2.856-2.855M23.43 24.993a2.856 2.856 0 0 1 2.856-2.856M5.714 22.135a2.856 2.856 0 0 1 2.856 2.856"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
export default SvgIcoSalaryBill;
